import { Suspense, lazy } from 'react';

import type { BoardCanvasProps } from './BoardCanvas';

/**
 * `@dnd-kit/*` must stay out of the entry bundle and every route that never
 * drags a card (constitution Principle 6) — this is the one place that
 * boundary is drawn. The fallback mirrors the canvas's own layout so there is
 * no visible shift once the real module resolves.
 */
const BoardCanvas = lazy(() =>
  import('./BoardCanvas').then((module) => ({ default: module.BoardCanvas })),
);

function BoardCanvasFallback() {
  return (
    <div
      data-testid="board-canvas"
      className="scrollbar-canvas bg-board-canvas border-border h-full min-h-[24rem] flex-1 overflow-auto rounded-lg border p-4"
      aria-hidden="true"
    >
      <div className="flex items-start gap-6">
        {Array.from({ length: 3 }, (_, i) => (
          <div
            key={i}
            className="border-border bg-muted/30 h-64 w-72 shrink-0 animate-pulse rounded-lg border"
          />
        ))}
      </div>
    </div>
  );
}

export function BoardCanvasLazy(props: BoardCanvasProps) {
  return (
    <Suspense fallback={<BoardCanvasFallback />}>
      <BoardCanvas {...props} />
    </Suspense>
  );
}
